<template>
  <div>

    <el-row>
      <el-col :span="24">
        <!--      搜索视图      -->
        <search
          :searchForm="searchForm"
          :operatorForSelect="operatorForSelect"
          :operatorTree="operatorTree"
          :searchLoading="searchLoading"
          @submitSearchForm="submitSearchForm"
          ref="searchForm"
        >
        </search>
        <el-form>
          <el-col :span="2" class="diy-class">
            <el-form-item>
              <el-button size="mini" type="primary" @click="pileAdd" icon="el-icon-plus" class="el-btn" >
                {{ $t('paramMonitor.add') }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-form>
        <!--列表数据-->
        <!--      列表组件       -->
        <list
          :pileDataTable="pileDataTable"
          :listLoading="listLoading"
          @showViewVisible="showViewVisible"
          @pileEdit="pileEdit"
          @pileDelete="pileDelete"
        ></list>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparam" @callFather="changePage"></Pagination>
      </el-col>
    </el-row>
    <!-- 编辑组件 -->
    <add
      :editForm="editForm"
      :editFormVisible="editFormVisible"
      :operatorForSelect="operatorForSelect"
      :operatorTree="operatorTree"
      :svipTypeEnum="enumData.svipTypeEnum"
      :yesOrNoEnum="enumData.yesOrNoEnum"
      :editSubmitLoading="editSubmitLoading"
      @closeEditForm="closeEditForm"
      @editSubmit="editSubmit"
    ></add>
    <!--   视图组件   -->
    <customizeView
      :view-visible="viewVisible"
      :detailForm="detailForm"
      @closeView="viewVisible=false"
    ></customizeView>

  </div>
</template>

<script>
  import Pagination from '@/module/operatingCenter/component/Pagination.vue';
  import commonApi from '@/module/resourceCenter/api/commonApi';
  import api from '../../api/gunBox.js';
  import search from "./search.vue";
  import list from "./list.vue"
  import customizeView from "./customizeView.vue";
  import add from "./add.vue";

  export default {
    name: 'deviceManager',
    data() {
      return {
        enumData: [{
          svipTypeEnum:'',
          yesOrNoEnum:'',
        }],
        operatorForSelect: '',
        operatorTree: [],
        showFilters: true,
        listLoading: false,
        pileDataTable: [{}],
        // 多选集合
        pileDataSelection: [],
        // 查询
        searchLoading: false,
        searchFormVisible: false,
        searchForm: {// 未初始化不传递参数，影响后台接查询
        },
        // 编辑
        editFormVisible: false,
        editSubmitLoading: false,
        viewVisible: false, // 视图
        editForm: {},
        // 详情
        detailForm: {},
        viewName: 'detailForm',
        formLabelWidth: '150px',
        // 分页参数
        pageparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
      };
    },
    methods: {
      resetSearchForm() {
        this.searchForm = {}
      },
      submitSearchForm() {
        this.$refs.searchForm.$children[0].validate((valid) => {
          if (!valid) {
            return;
          }
          this.searchLoading = true;
          this.listLoading = true;
          this.pageparam.t = this.searchForm;
          let param = Object.assign({}, this.pageparam);
          api.getList(param).then((res) => {
            if (res.code === 0) {
              this.pageparam.total = res.data.total;
              this.pileDataTable = res.data.list;
            } else {
              // this.$message.error(res.message);
            }
            this.searchLoading = false;
            this.listLoading = false;
          });
        })
      },
      showViewVisible(index, row) {
        this.detailForm = Object.assign({}, row);
        this.viewVisible = true;
      },
      closeEditForm(){
        this.editFormVisible = false
      },
      pileAdd() {
        this.$nextTick(() => {
          this.editFormVisible = true;
          this.editForm = Object.assign({
          });
        });
      },
      pileEdit(index, row) {
        this.editFormVisible = true;
        this.editForm = Object.assign({}, row);
      },
      editSubmit(editForm) {
        editForm.validate((valid) => {
          if (!valid) {
            return;
          } else {
            this.$confirm(this.$t('deviceControl.AreYouSureToSubmit'), this.$t('deviceControl.prompt'), {}).then(() => {
              this.editSubmitLoading = true;
              if(Array.isArray(this.editForm.operatorId)){
                this.editForm.operatorId = this.editForm.operatorId[0];
              }
              let param = JSON.stringify(this.editForm);
              if(this.editForm == '' || this.editForm.id == null){
                //  新增
                api.insert(param).then((res) => {
                  this.editSubmitLoading = false;
                  if (res.code === 0) {
                    this.editFormVisible = false;
                    this.submitSearchForm();
                  } else {

                  }
                }).catch((error) => {
                  this.editSubmitLoading = false;
                });
              }else{  //  修改
                api.update(param).then((res) => {
                  this.editSubmitLoading = false;
                  if (res.code === 0) {
                    this.editFormVisible = false;
                    this.submitSearchForm();
                  } else {

                  }
                }).catch((error) => {
                  this.editSubmitLoading = false;
                });
              }
            });
          }
        })
      },
      pileDelete(index, row) {
        this.$confirm(this.$t('que-ding-yao-shan-chu') + row.name + this.$t('ma-0'), this.$t('alaramMonitor.message5'), {
          confirmButtonText: this.$t('deviceControl.confirm'),
          cancelButtonText: this.$t('alaramMonitor.cancel'),
          type: 'warning'
        })
          .then(() => {
            api.deleteById(row.id).then((res) => {
              if (res.code === 0) {
                this.$message({
                  message: res.message,
                  type: 'success'
                });
                this.submitSearchForm();
              } else {
                this.$message.error(res.message);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('alaramMonitor.message8')
            });
          });
      },
      changePage() {
        this.submitSearchForm();
      },
      // 加载下拉框
      loadSelectItem() {
        api.getEnum().then((res) => {
          //  开放状态
          this.enumData.yesOrNoEnum = JSON.parse(res.yesOrNoEnum);
        });
        // 运营商下拉框
        commonApi.getOperatorsTree().then((res) => {
          if (res.code === 0) {
            this.operatorTree = res.data;
          }
        });
      },
    },
    components: {
      Pagination,
      search,
      list,
      customizeView,
      add
    },
    created: function () {
      this.loadSelectItem();
    },
    mounted: function () {
      this.submitSearchForm();
    },
    filters: {
      statusFilter(runStatus) {
        const statusMap = {
          0: 'success',
          1: 'info',
          2: 'danger',
          3: 'warning'
        }
        return statusMap[runStatus]
      }
    }
  };
</script>

<style lang="less" scoped>
  .el_search {
    background-color: teal;
    color: white;
  }

  .el_clear {
    background-color: darkorange;
    color: white;
  }
  /deep/.el-dialog{
    width: 900px;
  }
  /deep/ .edit_form, /deep/ .detail_form, /deep/ {
    height: 600px;
    overflow: auto;

    .el-form-item__label {
      color: rgba(0, 0, 0, 0.47);
    }
  }
  /deep/ .diy-class {
    .el-form-item__content {
      line-height: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/gunBox/gunBox.vue